import {
  TYPE_INVOICE,
  TYPE_REPORT,
} from "pages/ReportInvoiceError/helper/functionHelper";
import { call, put, select, takeEvery } from "redux-saga/effects";
import SummaryInvoiceDataService from "services/SummaryInvoiceDataService";
import {
  createInvoiceCyclesFail,
  createInvoiceCyclesSuccess,
  createReportInvoiceFail,
  createReportInvoiceSuccess,
  downloadReportInvoiceFail,
  downloadReportInvoiceSuccess,
  executeReportFail,
  executeReportSuccess,
  getReportInvoiceListFail,
  getReportInvoiceListSuccess,
  getReportInvoiceProgress,
  getReportInvoiceProgressFail,
  getReportInvoiceProgressSuccess,
  getSummaryInvoiceListFail,
  getSummaryInvoiceListSuccess,
  listInvoiceToSummaryFail,
  listInvoiceToSummarySuccess,
  listKhddInvoiceToSummaryFail,
  listKhddInvoiceToSummarySuccess,
  releaseInvoiceCyclesFail,
  releaseInvoiceCyclesSuccess,
  transferUsbInvoiceCyclesFail,
  transferUsbInvoiceCyclesSuccess,
} from "./actions";
import {
  CREATE_INVOICE_CYCLES,
  CREATE_REPORT_INVOICE,
  DOWNLOAD_REPORT_INVOICE,
  EXECUTE_REPORT,
  GET_REPORT_INVOICE_PROGRESS,
  LIST_INVOICE_TO_SUMMARY,
  LIST_KHDD_INVOICE_TO_SUMMARY,
  RELEASE_INVOICE_CYCLES,
  REPORT_INVOICE_LIST,
  SUMMARY_INVOICE_LIST,
  TRANSFER_USB_INVOICE_CYCLES,
} from "./actionTypes";

function* fetchListSummaryInvoiceList({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      SummaryInvoiceDataService.listInvoiceCycles,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getSummaryInvoiceListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getSummaryInvoiceListFail(error));
  }
}

function* fetchReportInvoiceList({ params, typeReport }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    let columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let response = null;
    // Call api
    let { buTenantHeader, buStoreHeader } = yield select(
      state => state.Dashboard
    );
    if (typeReport === TYPE_REPORT.ERROR) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 10,
        // "filter[bu_code]": buTenantHeader,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_INVOICE.REPLACE) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": buStoreHeader,
      };
      response = yield call(
        SummaryInvoiceDataService.listInvoiceReplace,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_INVOICE.ADJUST) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": buStoreHeader,
      };
      response = yield call(
        SummaryInvoiceDataService.listInvoiceAdjust,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": buStoreHeader,
        "filter[type]": typeReport,
      };
      //   if (!columnFilter["filter[type]"]) {
      //   columnFilter = {
      //     ...columnFilter,
      //     "filter[type][in]": typeReport,
      //   };
      //   }
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    }

    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getReportInvoiceListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getReportInvoiceListFail(error));
  }
}

function* fetchReleaseInvoiceCycles({ id }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.releaseInvoiceCycles,
      id
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseInvoiceCyclesSuccess());
    } else {
      yield put(
        releaseInvoiceCyclesFail("Gửi phát hành bảng tổng hợp dữ liệu thất bại")
      );
    }
  } catch (error) {
    yield put(
      releaseInvoiceCyclesFail("Gửi phát hành bảng tổng hợp dữ liệu thất bại")
    );
  }
}

function* fetchListInvoiceToSummary({ params, khmshdon }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.searchInvoice,
      params,
      khmshdon
    );
    if (response.result) {
      response.items = response.items.map(item => {
        return {
          ...item,
          sTbao: "",
          dateTbao: "",
          noteTbao: "",
          newStatus: "Giữ nguyên",
        };
      });
      yield put(listInvoiceToSummarySuccess(response.items));
    } else {
      yield put(listInvoiceToSummaryFail("fetchListInvoiceToSummary Fail"));
    }
  } catch (error) {
    yield put(listInvoiceToSummaryFail("fetchListInvoiceToSummary Fail"));
  }
}

function* fetchListKHDDInvoiceToSummary({ id }) {
  try {
    const response = yield call(SummaryInvoiceDataService.searchKHDD, id);
    if (response.result) {
      yield put(listKhddInvoiceToSummarySuccess(response.items));
    } else {
      yield put(
        listKhddInvoiceToSummaryFail("fetchListKHDDInvoiceToSummary Fail")
      );
    }
  } catch (error) {
    yield put(
      listKhddInvoiceToSummaryFail("fetchListKHDDInvoiceToSummary Fail")
    );
  }
}

function* fetchCreateInvoiceCycles({ data }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.createInvoiceCycles,
      data
    );
    if (response) {
      yield put(createInvoiceCyclesSuccess());
    } else {
      yield put(createInvoiceCyclesFail("Tạo bảng tổng hợp dữ liệu thất bại"));
    }
  } catch (error) {
    yield put(createInvoiceCyclesFail("Tạo bảng tổng hợp dữ liệu thất bại"));
  }
}

function* fetchCreateReportInvoice({ data, typeReport }) {
  try {
    let response = null;
    let { buTenantHeader, buStoreHeader } = yield select(
      state => state.Dashboard
    );
    if (typeReport === TYPE_REPORT.ERROR) {
      response = yield call(
        SummaryInvoiceDataService.createReportInvoiceError,
        data,
        buTenantHeader
      );
    } else {
      response = yield call(
        SummaryInvoiceDataService.createReportInvoice,
        data,
        typeReport
      );
    }
    if (response && response.id) {
      yield put(getReportInvoiceProgress(response.id));
      yield put(createReportInvoiceSuccess());
    } else {
      yield put(createReportInvoiceFail("Tạo bảng kê hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(createReportInvoiceFail("Tạo bảng kê hóa đơn thất bại"));
  }
}

function* fetchGetReportInvoiceProgress({ id }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.progressReportInvoice,
      id
    );
    if (response && response.result) {
      let reportInvoiceProgress = yield select(
        state => state.summaryInvoiceData.reportInvoiceProgress
      );
      if (response.percent !== 100 && reportInvoiceProgress.isStart) {
        yield sleep(1);
        yield put(getReportInvoiceProgress(id));
      }
      yield put(getReportInvoiceProgressSuccess(response.percent));
    } else {
      yield put(
        getReportInvoiceProgressFail("Tiến trình bảng kê hóa đơn thất bại")
      );
    }
  } catch (error) {
    yield put(
      getReportInvoiceProgressFail("Tiến trình bảng kê hóa đơn thất bại")
    );
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

function* fetchTransferUsb({ id, typeSend, content }) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(SummaryInvoiceDataService.transfer, data);
    if (response.result) {
      yield sleep(1);
      yield put(transferUsbInvoiceCyclesSuccess());
    } else {
      yield put(transferUsbInvoiceCyclesFail(response?.error?.content));
    }
  } catch (error) {
    yield put(
      transferUsbInvoiceCyclesFail("Gửi phát hành bảng tổng hợp thất bại")
    );
  }
}

function* fetchDownloadReport({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.downloadReport,
      resource_id,
      responseType
    );
    if (
      response.size > 0 &&
      response.size !== undefined &&
      response.size !== null
    ) {
      const file = URL.createObjectURL(response);
      yield put(
        downloadReportInvoiceSuccess(null, file, fileDownloadName + ".xlsx")
      );
    } else {
      yield put(downloadReportInvoiceFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadReportInvoiceFail(error));
  }
}

function* fetchExecuteReport({ id }) {
  try {
    const response = yield call(SummaryInvoiceDataService.executeReport, id);
    if (response.result) {
      yield put(executeReportSuccess());
    } else {
      yield put(executeReportFail(response?.error?.content));
    }
  } catch (error) {
    yield put(executeReportFail("fetchExecuteReport fail"));
  }
}

function* summaryInvoiceDataSaga() {
  yield takeEvery(SUMMARY_INVOICE_LIST, fetchListSummaryInvoiceList);
  yield takeEvery(REPORT_INVOICE_LIST, fetchReportInvoiceList);
  yield takeEvery(RELEASE_INVOICE_CYCLES, fetchReleaseInvoiceCycles);
  yield takeEvery(CREATE_INVOICE_CYCLES, fetchCreateInvoiceCycles);
  yield takeEvery(CREATE_REPORT_INVOICE, fetchCreateReportInvoice);
  yield takeEvery(GET_REPORT_INVOICE_PROGRESS, fetchGetReportInvoiceProgress);
  yield takeEvery(LIST_INVOICE_TO_SUMMARY, fetchListInvoiceToSummary);
  yield takeEvery(LIST_KHDD_INVOICE_TO_SUMMARY, fetchListKHDDInvoiceToSummary);
  yield takeEvery(TRANSFER_USB_INVOICE_CYCLES, fetchTransferUsb);
  yield takeEvery(DOWNLOAD_REPORT_INVOICE, fetchDownloadReport);
  yield takeEvery(EXECUTE_REPORT, fetchExecuteReport);
}

export default summaryInvoiceDataSaga;
